import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  useQuery,
  UseQueryOptions,
} from "react-query";
import {
  getAllProjectByUserIdRequest,
  getHackathonMyProjectRequest,
  getImportableProject,
  getProjectByIdRequest,
  getProjectTopicListRequest,
  getListSoftwareRequest,
  getListSoftwareBaseRequest,
  getListInfinitySoftwareRequest,
  getListProjectReview,
  getListRelativeProject,
} from "./request";
import {
  IProject,
  IProjectInProgress,
  IProjectTopic,
  IUserProject,
  IListSoftwarePayload,
  IListSoftware,
  IListSoftwareBase,
  IInfinitySoftwarePayload,
  IInfinitySoftware,
  IProjectReview,
  IRelativeProject,
} from "./types";

export const useProject = (
  id: string,
  option?: UseQueryOptions<IProject, Error>
) => {
  return useQuery<IProject, Error>(
    ["project", id],
    () => getProjectByIdRequest(id),
    option
  );
};

export const useUserProjects = (
  userId: string,
  option?: UseQueryOptions<IUserProject, Error>
) => {
  return useQuery<IUserProject, Error>(
    ["userProject", userId],
    () => getAllProjectByUserIdRequest(userId),
    option
  );
};

export const useHackathonMyProject = (
  hackathonId: string,
  option?: UseQueryOptions<IProjectInProgress[], Error>
) => {
  return useQuery<IProjectInProgress[], Error>(
    ["hackathonMyProject", hackathonId],
    () => getHackathonMyProjectRequest(hackathonId),
    option
  );
};

export const useImportableProject = (
  hackathonId: string,
  option?: UseQueryOptions<IProject[], Error>
) => {
  return useQuery<IProject[], Error>(
    ["importableProjects", hackathonId],
    () => getImportableProject(hackathonId),
    option
  );
};

export const useProjectTopicList = (
  projectId: string,
  option?: UseQueryOptions<IProjectTopic[], Error>
) => {
  return useQuery<IProjectTopic[], Error>(
    ["ProjectTopicList", projectId],
    () => getProjectTopicListRequest(projectId),
    option
  );
};

export const useInfinityListSoftware = (
  filterParams: IListSoftwarePayload,
  option?: UseInfiniteQueryOptions<IListSoftware, Error>
) => {
  return useInfiniteQuery<IListSoftware, Error>(
    ["listInfinitySoftware", filterParams],
    ({ pageParam = 1 }) => {
      const params = { ...filterParams };
      params.page = pageParam;
      return getListSoftwareRequest(params);
    },
    option
  );
};

export const useInfinitySoftware = (
  filterParams: IInfinitySoftwarePayload,
  option?: UseInfiniteQueryOptions<IInfinitySoftware, Error>
) => {
  return useInfiniteQuery<IInfinitySoftware, Error>(
    ["infinitySoftware", filterParams],
    ({ pageParam = 1 }) => {
      const params = { ...filterParams };
      params.page = pageParam;
      return getListInfinitySoftwareRequest(params);
    },
    option
  );
};

export const useListSoftWare = (
  option?: UseQueryOptions<IListSoftwareBase, Error>
) => {
  return useQuery<IListSoftwareBase, Error>(
    "listSoftware",
    () => getListSoftwareBaseRequest(),
    option
  );
};
export const useListProjectReview = (
  projectId: string,
  option?: UseQueryOptions<IProjectReview[], Error>
) => {
  return useQuery<IProjectReview[], Error>(
    ["review/list_by_project", projectId],
    () => getListProjectReview(projectId),
    option
  );
};

export const useListRelativeProject = (
  projectId: string,
  option?: UseQueryOptions<IRelativeProject, Error>
) => {
  return useQuery<IRelativeProject, Error>(
    ["project/relative", projectId],
    () => getListRelativeProject(projectId),
    option
  );
};
